module.exports = __webpack_public_path__ + "static/fonts/pan.26875b7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/pan.ttf
// module id = ZKr+
// module chunks = 1